/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type TuberculosisHistoryDtoPreviousLatentTuberculosisTreatment =
  (typeof TuberculosisHistoryDtoPreviousLatentTuberculosisTreatment)[keyof typeof TuberculosisHistoryDtoPreviousLatentTuberculosisTreatment];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TuberculosisHistoryDtoPreviousLatentTuberculosisTreatment = {
  YES: 'YES',
  NO: 'NO',
  UNKNOWN: 'UNKNOWN',
} as const;
